
// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';

export default function BottomMenuSpaced() {
    return (
        <div className="bottom-menu-spaced" />
    );
}
